var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"motor-recommendations",class:_vm.device},[_c('motor-list',{on:{"openModal":function($event){return _vm.$emit('openModal')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }